import img0 from "@/assets/image/brandImage/0.jpg";
import img1 from "@/assets/image/brandImage/1.jpg";
import img2 from "@/assets/image/brandImage/2.jpg";
import img3 from "@/assets/image/brandImage/3.jpg";
import img4 from "@/assets/image/brandImage/4.jpg";
import img5 from "@/assets/image/brandImage/5.jpg";
import img6 from "@/assets/image/brandImage/6.jpg";
import img7 from "@/assets/image/brandImage/7.jpg";
import img8 from "@/assets/image/brandImage/8.jpg";
import img9 from "@/assets/image/brandImage/9.jpg";
import img10 from "@/assets/image/brandImage/10.jpg";
import img11 from "@/assets/image/brandImage/11.jpg";
import img12 from "@/assets/image/brandImage/12.jpg";
import img13 from "@/assets/image/brandImage/13.jpg";
import img14 from "@/assets/image/brandImage/14.jpg";
import img15 from "@/assets/image/brandImage/15.jpg";
import img16 from "@/assets/image/brandImage/16.jpg";
import img17 from "@/assets/image/brandImage/17.jpg";
import img18 from "@/assets/image/brandImage/18.jpg";
import img19 from "@/assets/image/brandImage/19.jpg";
import img20 from "@/assets/image/brandImage/20.jpg";
import img21 from "@/assets/image/brandImage/21.jpg";
export default {
  0: img0,
  1: img1, // 华尔道夫酒店及度假村
  2: img2, //康莱德酒店及度假村
  3: img3, // LXR酒店及度假村
  4: img4, // NoMad
  5: img5, // Signia by Hilton
  6: img6, // 希尔顿嘉悦里酒店
  7: img7, // 希尔顿格芮精选酒店
  8: img8, // 希尔顿启缤精选酒店
  9: img9, // Tempo by Hilton
  10: img10, // Motto by Hilton
  11: img11, // Graduate
  12: img12, // 希尔顿酒店及度假村
  13: img13, // 希尔顿逸林酒店及度假村
  14: img14, // 希尔顿花园酒店
  15: img15, // 希尔顿欢朋酒店
  16: img16, // Tru by Hilton
  17: img17, // Spark
  18: img18, // 希尔顿安泊酒店
  19: img19, // 希尔顿欣庭酒店
  20: img20, // 希尔顿惠庭酒店
  21: img21, // LivSmart Studios by Hilton
};
